// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Switch, Route, Redirect, useParams } from "react-router-dom";
import CreateModal from "../pages/upload/createModal";
import MyModels from "../pages/myModels/myModels";
import InvoiceManagement from "../pages/invoiceManagement/invoiceManagement";
import EditorPageFor_INV from "../pages/invoiceManagement/EditTagsForInvoiceManagement";

import DocumentManagement from "../pages/documentManagement/documentManagement";


import UploadFile from "../pages/upload/uploadFiles";

import PUploadFile from "../pages/prebuiltInvoice/upload/uploadFiles";
import PEditorPageOCR from "../pages/prebuiltInvoice/editorPage/editorPage";
 

import ODUploadFile from "../pages/ODUploadFile/ODUploadFile";
import DashBoard from "../pages/dashboard/dashboard";
import dashboardpb from "../pages/dashboard/dashboardpb";
import BatchProcess from "../pages/operations/batchProcess";
import ErrorReviewProcess from "../pages/operations/errorReviewProcess";
import EditTagsData from "../pages/operations/EditTagsData";

import batchProcesspb from "../pages/operations/batchProcesspb";

import QueuesList from "../pages/operations/queuesList";

import TestQueues from "../pages/operations/testQueues";


import OperationProjects from "../pages/operations/loadProjects";
import Analysis from "../pages/analysis/analysis";
import AnalysisOD from "../pages/analysisimg/analysis";
import Test from "../pages/test/test";
//import Testo from "../pages/test/testo";
import TestUploadFiles from "../pages/testUploadFiles/editorPage";
import ODTestUploadFiles from "../pages/testUploadFilesimg/editorPage";
import AdvancedFeatures from "../pages/adavancedFeatures/adavancedFeatures";
import ODAdvancedFeatures from "../pages/ODadavancedFeatures/adavancedFeatures";

import Login from "../pages/login/login";
import Register from "../pages/login/register";
import Profile from "../pages/profile/profile";
import ChangePassword from "../pages/profile/changePassword";
import EditorPage from "../pages/editorPage/editorPage";
import EditorPageOCR from "../pages/editorPageFR/editorPage";
import EditorPageOD from "../pages/editorPageimg/editorPage";
import ProtectedRoute from "./protected-route";
import PostProcessing from "../pages/operations/postProcessing";
import EditorPage_Post_Process from "../pages/operations/editTagsData_postProcessing";
import  DocumentEditTags from '../pages/documentManagement/documentManagementEditTags';
import  OrderEditTags from '../pages/orderManagement/orderManagementEditTags';


import OrderManagement from "../pages/orderManagement/orderManagement";

import Admin from "../pages/admin/admin";
  

/**
 * @name - Main Content Router
 * @description - Controls main content pane based on route
 */
export function MainContentRouter({ loggedUser }) {

    return (
        <div className="app-content text-light">
            <Switch>
                <Route path="/login" exact component={Login} />
                <Route path="/change-password" loggedUser={loggedUser} component={ChangePassword} />
                <ProtectedRoute path="/register" loggedUser={loggedUser} component={Register} />
                <ProtectedRoute path="/profile" loggedUser={loggedUser}  component={Profile} />
                <ProtectedRoute path="/dashboard" loggedUser={loggedUser} component={DashBoard} />
               
                <ProtectedRoute path="/dashboardpb" loggedUser={loggedUser} component={dashboardpb} />
               
               
                <ProtectedRoute loggedUser={loggedUser} path="/create-model" component={CreateModal} />
                <ProtectedRoute loggedUser={loggedUser} path="/my-models" component={MyModels} />
                <ProtectedRoute loggedUser={loggedUser} path="/invoiceManagement" component={InvoiceManagement} />
                <ProtectedRoute loggedUser={loggedUser} path="/editTagsForInv" component={EditorPageFor_INV} />

                <ProtectedRoute loggedUser={loggedUser} path="/documentManagement" component={DocumentManagement} />

                <ProtectedRoute loggedUser={loggedUser} path="/orderManagement" component={OrderManagement} />



                {/* <ProtectedRoute loggedUser={loggedUser} path="/operations/projects" component={OperationProjects} /> */}
                <ProtectedRoute loggedUser={loggedUser} path="/operations/projects" component={QueuesList} />
                
                <ProtectedRoute loggedUser={loggedUser} path="/operations/TestQueueProjects/:filesCount?" component={TestQueues} />
                <ProtectedRoute loggedUser={loggedUser} path="/operations/queues" component={QueuesList} />
                <ProtectedRoute loggedUser={loggedUser} path="/operations/batch-process1" component={BatchProcess} />
               
                <ProtectedRoute loggedUser={loggedUser} path="/operations/batch-process" component={batchProcesspb} />
               
               
                <ProtectedRoute loggedUser={loggedUser} path="/operations/errorReviewProcess" component={ErrorReviewProcess} />
                <ProtectedRoute loggedUser={loggedUser} path="/operations/postProcess" component={PostProcessing} />

               
                <ProtectedRoute loggedUser={loggedUser} path="/operations/editTagsData" component={EditTagsData} />
                <ProtectedRoute loggedUser={loggedUser} path="/operations/editTagsData_for_PP" component={EditorPage_Post_Process} />
                <ProtectedRoute loggedUser={loggedUser} path="/editTagsData_for_Document" component={DocumentEditTags} />

                <ProtectedRoute loggedUser={loggedUser} path="/editTagsData_for_OrderDocument" component={OrderEditTags} />

                <ProtectedRoute loggedUser={loggedUser} path="/Prebuilt/uploadfiles/:projectName/:schema?/:type?/:projectId?" component={PUploadFile} />
                
                <ProtectedRoute loggedUser={loggedUser} path="/Prebuilt/Projects/:projectName/:projectId/:type?/edit/:schema?" component={PEditorPageOCR} />
           



                <ProtectedRoute loggedUser={loggedUser} path="/upload-files/:projectName/:schema?/:type?/:projectId?" component={UploadFile} />
                <ProtectedRoute loggedUser={loggedUser} path="/ODuploadfiles/:projectName/:schema?/:type?/:projectId?" component={ODUploadFile} />

                
              
                <ProtectedRoute loggedUser={loggedUser} path="/projects/:projectName/:projectId/edit/:schema?" component={EditorPage} />
                {/* <ProtectedRoute loggedUser={loggedUser} path="/projectsFR/:projectName/:projectId/edit/:schema?" component={EditorPageFR} />*/}
            <ProtectedRoute loggedUser={loggedUser} path="/OCRProjects/:projectName/:projectId/:type?/edit/:schema?" component={EditorPageOCR} />
           
           
            <ProtectedRoute loggedUser={loggedUser} path="/ODProjects/:projectName/:projectId/:type?/edit/:schema?" component={EditorPageOD }/>
              
              
               {/*  <ProtectedRoute loggedUser={loggedUser} path="/projects/:projectName/:projectId/analysis" component={Analysis} /> */}
             
               <ProtectedRoute loggedUser={loggedUser} path="/OCRProjects/:projectName/:projectId/ocr/analysis" component={Analysis} />
               <ProtectedRoute loggedUser={loggedUser} path="/ODProjects/:projectName/:projectId/od/analysis" component={AnalysisOD} />
             
                <ProtectedRoute loggedUser={loggedUser} path="/:Projects/:projectName/:projectId/:schema?/:type?/test" component={Test} />
                
               
                <ProtectedRoute loggedUser={loggedUser} path="/projectsFR/:projectName/:projectId/test-files/:schema?" component={TestUploadFiles} />
              
                <ProtectedRoute loggedUser={loggedUser} path="/OCRProjects/:projectName/:projectId/ocr/test-files/:schema?" component={TestUploadFiles} />
              
                <ProtectedRoute loggedUser={loggedUser} path="/ODProjects/:projectName/:projectId/od/test-files/:schema?" component={ODTestUploadFiles} />
              
              
                {/*<ProtectedRoute loggedUser={loggedUser} path="/projects/:projectName/:projectId/:schema?/test-files" component={TestUploadFiles} />*/}
                <ProtectedRoute loggedUser={loggedUser} path="/OCRProjects/:projectName/:projectId/advanced-features" component={AdvancedFeatures} />
                <ProtectedRoute loggedUser={loggedUser} path="/ODProjects/:projectName/:projectId/advanced-features" component={ODAdvancedFeatures} />
              
              
                <ProtectedRoute path="/admin" loggedUser={loggedUser} component={Admin} />
               
               
                <Route path="/">
                    <Redirect to="/login" />
                </Route>
            </Switch>
        </div>
    );
}
